module.exports = __webpack_public_path__ + "img/banner01.177eea9e.webp";